// @ts-expect-error: @rails/request.js is not typed
import { FetchRequest } from '@rails/request.js'
import { useMutation } from '@tanstack/react-query'

import { type ChargeOrTxn } from 'utils/web_api.schemas'

import { GrapeAPIError, type GrapeAPIErrorType } from '../GrapeAPIError'

export type ModifyEnrollmentPaymentParams = {
  transactionId: string
  enrollmentId: string
}

export function useModifyEnrollmentPayment ({ memberId } : { memberId: string }) {
  return useMutation<ChargeOrTxn, GrapeAPIErrorType, ModifyEnrollmentPaymentParams>({
    mutationFn: async ({ transactionId, enrollmentId, }) => {
      const queryString = new URLSearchParams({
        enrollment_id: enrollmentId,
      }).toString()

      const request = new FetchRequest(
        'patch',
        `/api/web/brokers/members/${memberId}/transactions/${transactionId}?${queryString}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          }
        }
      )
      const response = await request.perform()
      if (!response.ok) {
        const errors = await response.json
        throw GrapeAPIError({
          status: response.status,
          message: errors.message,
          errors: errors.errors,
        })
      }
      return response.json
    },
  })
}
